module.exports = __webpack_public_path__ + "img/shield.adbf3dd8.svg";